var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInventoryandcontrolofsoftwareassets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "69px",
    viewBox: "0 0 76.0 69.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1561,0 L1561,1080 L0,1080 L0,0 L1561,0 Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i1",
    x: "-48.4375659%",
    y: "-55.9321967%",
    filterUnits: "userSpaceOnUse",
    width: "168.750094%",
    height: "174.576282%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    stdDeviation: 5.5,
    dx: 0,
    dy: 0,
    floodColor: "rgba(2, 255, 225, 0.304128)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4222284,0.0009682927 L11.6289555,0.00358518234 C12.9613916,0.0730652313 14.0052913,1.2150174 14.0052913,2.60279249 L14.0052913,2.89974042 L15.2423874,2.89974042 C16.1702338,2.89974042 16.9256938,3.64941381 16.9256938,4.57062508 L16.9256938,6.5560439 L20.7874936,6.5560439 L20.9445002,6.56154014 C22.0848513,6.64169613 22.9880554,7.58853857 22.9880554,8.74077341 L22.9883458,31.9459566 C22.9883458,33.1505657 22.0011661,34.1308783 20.7878807,34.1308783 L2.2012394,34.1308783 C0.987566861,34.1308783 0.000387167249,33.1507579 0.000387167249,31.9461488 L0,8.74106171 C0,7.53606816 0.987179694,6.55594781 2.20085223,6.55594781 L6.06458779,6.55594781 L6.06458779,4.57052898 C6.06458779,3.64931771 6.82004789,2.89964432 7.7478942,2.89964432 L8.98499036,2.89964432 L8.98499036,2.49237399 C8.98499036,1.81218065 9.27004224,1.15303313 9.76726178,0.684547322 C10.2716439,0.209238439 10.9367005,-0.032836586 11.6289555,0.00358518234 Z M6.60546044,7.63274441 L2.20162656,7.63236002 C1.58612743,7.63236002 1.08474584,8.12977182 1.08474584,8.74086951 L1.08474584,31.9460527 C1.08474584,32.5575347 1.58612743,33.0545622 2.20162656,33.0545622 L20.7875904,33.0545622 C21.4034767,33.0545622 21.9040839,32.5571503 21.9040839,31.9460527 L21.9046647,8.74086951 C21.9046647,8.12977182 21.403767,7.63236002 20.7881711,7.63236002 L16.3861763,7.63274441 L6.60720269,7.63312881 Z M11.5723323,1.0782676 C11.1775185,1.05991257 10.8006112,1.19502868 10.5136234,1.4649726 C10.2266357,1.73491653 10.0689619,2.10019131 10.0689619,2.49208569 L10.0689619,3.43761017 C10.0689619,3.7349425 9.826208,3.97596043 9.52673413,3.97596043 L7.74779741,3.97596043 C7.41735016,3.97596043 7.1485593,4.24244477 7.1485593,4.57062508 L7.14865609,6.55594781 L15.841432,6.5563322 L15.841432,4.57091338 C15.841432,4.24321356 15.5726411,3.97624873 15.2420971,3.97624873 L13.4631603,3.97624873 C13.1633961,3.97624873 12.9210294,3.7352308 12.9210294,3.43799457 L12.9210294,2.60269639 C12.9210294,1.80093699 12.3159838,1.11738016 11.5723323,1.0782676 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,0 L44,37 L0,37 L0,0 L44,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0257766,0 C17.3252504,0 17.5680043,0.241017929 17.5680043,0.537965856 L17.5680043,21.6549035 C17.5680043,21.9521398 17.3252504,22.1931577 17.0257766,22.1931577 L0.542130941,22.1935421 C0.242269906,22.1935421 0,21.9525242 0,21.6552879 L0,0.538350255 C0,0.241017929 0.242657074,0 0.542130941,0 Z M16.4836456,1.07631611 L1.08503622,1.07631611 L1.08503622,21.1169377 L16.4836456,21.1169377 L16.4836456,1.07631611 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.84385867,0 C7.14371971,0 7.38608641,0.241017929 7.38608641,0.538254155 C7.38608641,0.835586481 7.14333254,1.07660441 6.84385867,1.07660441 L0.542227733,1.07660441 C0.242753865,1.07660441 0,0.835586481 0,0.538254155 C0,0.241017929 0.242753865,0 0.542227733,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.20505806,0 C1.50482231,0 1.747189,0.241017929 1.747189,0.538254155 C1.747189,0.835586481 1.50443514,1.07660441 1.20505806,1.07660441 L0.542227733,1.07660441 C0.242753865,1.07660441 0,0.835586481 0,0.538254155 C0,0.241017929 0.242753865,0 0.542227733,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.84385867,0 C7.14371971,0 7.38608641,0.241017929 7.38608641,0.538254155 C7.38608641,0.835586481 7.14333254,1.07660441 6.84385867,1.07660441 L0.542227733,1.07660441 C0.242753865,1.07660441 0,0.835586481 0,0.538638554 C0,0.241402328 0.242753865,0.000384398611 0.542227733,0.000384398611 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.20505806,0 C1.50482231,0 1.747189,0.241017929 1.747189,0.538254155 C1.747189,0.835586481 1.50443514,1.07660441 1.20505806,1.07660441 L0.542227733,1.07660441 C0.242753865,1.07660441 0,0.835586481 0,0.538254155 C0,0.241017929 0.242753865,0 0.542227733,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.84385867,0 C7.14371971,0 7.38608641,0.241017929 7.38608641,0.538254155 C7.38608641,0.835586481 7.14333254,1.07660441 6.84385867,1.07660441 L0.542227733,1.07660441 C0.242753865,1.07660441 0,0.835586481 0,0.538638554 C0,0.241402328 0.242753865,0.000384398611 0.542227733,0.000384398611 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.84385867,0 C7.14371971,0 7.38608641,0.241017929 7.38608641,0.538254155 C7.38608641,0.835586481 7.14333254,1.07660441 6.84385867,1.07660441 L0.542227733,1.07660441 C0.242753865,1.07660441 0,0.835586481 0,0.538254155 C0,0.241017929 0.242753865,0 0.542227733,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.20505806,0 C1.50482231,0 1.747189,0.241017929 1.747189,0.538254155 C1.747189,0.835586481 1.50443514,1.07660441 1.20505806,1.07660441 L0.542227733,1.07660441 C0.242753865,1.07660441 0,0.835586481 0,0.538254155 C0,0.241017929 0.242753865,0 0.542227733,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.21564507,0.278839208 C3.47658167,0.0234161551 3.83316705,-0.0638997646 4.16290366,0.0475959482 C4.49247246,0.158899758 4.75022077,0.453854854 4.84788321,0.830752582 C4.94537785,1.20803412 4.86902663,1.61582825 4.64567832,1.9142376 L2.44474941,4.43680411 L4.64567832,6.95937063 C4.86030077,7.16950454 4.9883359,7.47271147 4.99924322,7.79549252 C5.01015054,8.11846547 4.90275541,8.43184327 4.70289979,8.66059179 C4.50321197,8.8889565 4.22918659,9.0117745 3.94677096,8.99910889 C3.66435534,8.98663519 3.39939142,8.84021311 3.21564507,8.59476902 L0.294665383,5.25450331 C0.105884884,5.03726898 0,4.7432734 0,4.43680411 C0,4.13033483 0.105884884,3.83653115 0.294665383,3.61929682 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.05322904,0.000884149658 C1.33564466,0.0132772624 1.60060858,0.15875334 1.78435493,0.402611667 L4.70533462,3.72148727 C4.89411512,3.9373181 5,4.22922357 5,4.53371282 C5,4.83820206 4.89411512,5.13010754 4.70533462,5.34593836 L1.78435493,8.66481397 C1.5943998,8.87931015 1.33732271,9 1.06950611,9 C0.8013539,9 0.544444617,8.87931015 0.354321679,8.66481397 C0.16554118,8.44879248 0.0596562961,8.156887 0.0596562961,7.85220709 C0.0596562961,7.54790851 0.16554118,7.25581237 0.354321679,7.03998155 L2.55525059,4.53371282 L0.354321679,2.02744408 C0.139699228,1.8186678 0.0116640981,1.51741983 0.000756780407,1.1967242 C-0.0101505373,0.875837912 0.0972445909,0.564484786 0.297100212,0.337214164 C0.496788029,0.110515532 0.770813411,-0.0116996264 1.05322904,0.000884149658 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.80248346,0.0168370011 C4.15720084,-0.0534390578 4.51769426,0.0992570815 4.75213391,0.41918237 C4.98657356,0.73930674 5.06115255,1.17967683 4.94817982,1.58023046 L1.99118237,11.2058606 C1.9194914,11.4383888 1.78851099,11.6392628 1.61556928,11.7814076 C1.44313722,11.9237515 1.23723805,12 1.02624237,12 C0.907153827,11.9990046 0.789254469,11.9745175 0.67713116,11.9277331 C0.421116271,11.8192333 0.212498962,11.596062 0.0969779773,11.3069944 C-0.0183731241,11.0183251 -0.0314541768,10.6876493 0.0611324951,10.3878314 L3.01796006,0.762201207 C3.14995978,0.369809954 3.44742631,0.0869139777 3.80248346,0.0168370011 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-292.0 -992.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(308.0 1008.0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#i1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.01156708248737 8.944669161792262e-06)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-4.33680869e-19 22.9883458,-4.33680869e-19 22.9883458,34.1308783 0,34.1308783 0,-4.33680869e-19",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.721147397798227 9.246804686546282)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 17.5680043,0 17.5680043,22.1935421 0,22.1935421 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.549732324547556 14.62713594464662)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.38608641,0 7.38608641,1.07660441 0,1.07660441 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.07490626173887 14.62713594464662)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.747189,0 1.747189,1.07660441 0,1.07660441 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.549732324547556 18.07903547116098)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.38608641,0 7.38608641,1.07660441 0,1.07660441 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.07490626173887 18.07903547116098)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.747189,0 1.747189,1.07660441 0,1.07660441 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.549732324547556 21.530925387710113)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i9)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.38608641,0 7.38608641,1.07660441 0,1.07660441 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.07490626173887 21.530925387710113)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.747189,0 1.747189,1.07660441 0,1.07660441 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.549732324547556 24.983785910751983)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i10)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.38608641,0 7.38608641,1.07660441 0,1.07660441 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.07490626173887 24.983785910751983)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i11)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.747189,0 1.747189,1.07660441 0,1.07660441 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0 26.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i12)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-1.03389519e-15 5,-1.03389519e-15 5,9 0,9 0,-1.03389519e-15",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.0 26.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i13)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-2.77555756e-16,1.27892488e-15 5,1.27892488e-15 5,9 -2.77555756e-16,9 -2.77555756e-16,1.27892488e-15",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.0 25.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i14)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "8.46545056e-16,9.43689571e-16 5,9.43689571e-16 5,12 8.46545056e-16,12 8.46545056e-16,9.43689571e-16",
    stroke: "none",
    fill: "#55BAB0"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryandcontrolofsoftwareassets);
export default __webpack_public_path__ + "static/media/inventoryandcontrolofsoftwareassets.832bdb81ffa87b4afd7f1cba26ce9880.svg";
export { ForwardRef as ReactComponent };